import type { CaseStudy } from '@/domain/content'

export const isPrivateCaseStudy = (caseStudy: CaseStudy) => caseStudy.visibility === 'private'

export const isPublicCaseStudy = (caseStudy: CaseStudy) => !isPrivateCaseStudy(caseStudy)
